/* eslint-disable no-undef */
class Zoom {
    _map = null
    /**
     * @type {HTMLDivElement}
     */
    _container = null
    options = {}

    constructor(options = {}) {
        this.options = { ...options }
        this._onMove = this._onMove.bind(this)
    }

    getDefaultPosition() {
        return 'bottom-left'
    }

    _onMove(evt) {
        this._updateZoom(this._map, this._container, this.options)
    }

    onAdd(map) {
        this._map = map
        this._container = GeoGlobe.DOM.create(
            'div',
            'mapboxgl-ctrl mapboxgl-ctrl-zoom',
            map.getContainer()
        )
        this._container.style.width = '30px'
        this._container.style.height = '30px'
        this._container.style.lineHeight = '30px'
        this._container.style.textAlign = 'center'
        this._container.style.background = '#fff'
        this._container.style.fontWeight = 'bold'
        this._container.style.fontSize = '16px'
        this._container.style.boxShadow = '0 0 0 2px rgba(0, 0, 0, 0.1)'

        this._map.on('zoomend', this._onMove)
        this._onMove()

        return this._container
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container)
        this._map.off('zoomend', this._onMove)
        this._map = undefined
    }

    _updateZoom(map, container, options) {
        const zoom = map.getZoom() + (options.offset || 0)
        container.innerHTML = Math.round(zoom)
    }
}

export default Zoom
